import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { Skeleton } from '~/components/PreviewCard/Skeleton'
import GET_FEED_ITEMS from '~/graphql/queries/getFeedItems'
import getGeoInfo from '~/utils/getGeoInfo'
import BlogCard from './BlogCard'
import EventCollectionCard from './EventCollectionCard'
import { useViewer } from '~/components/ViewerContext'
import UrlCard from './UrlCard'
import GroupCollectionCard from './GroupCollectionCard'
import RecurringEventCollectionCard from './RecurringEventCollectionCard'

const DiscoverFeed = ({ t }) => {
  const { viewer } = useViewer()
  const userIsEmployee = viewer ? viewer.isEmployee : false
  const { countryCode } = getGeoInfo()
  const { data, loading } = useQuery(GET_FEED_ITEMS, {
    variables: {
      countryCode,
    },
  })

  if (loading) return <Skeleton />
  if (!data) return null

  const { explore } = data
  const { feed } = explore
  const { edges = [] } = feed
  const feedItems = edges.filter(({ node }) => node.status !== 'PREVIEW' || userIsEmployee)

  return (
    <>
      {feedItems.map(({ node }, index) => {
        switch (node.type) {
          case 'THUMBNAIL_BLOG':
            return <BlogCard key={node.id} t={t} blog={node} itemOrder={index} />
          case 'THUMBNAIL_EVENT_COLLECTION':
            return (
              <EventCollectionCard key={node.id} t={t} eventCollection={node} itemOrder={index} />
            )
          case 'THUMBNAIL_WITH_URL':
            return <UrlCard key={node.id} urlCollection={node} itemOrder={index} />
          case 'GROUP_COLLECTION':
            return (
              <GroupCollectionCard key={node.id} t={t} groupCollection={node} itemOrder={index} />
            )
          case 'RECURRING_EVENT_COLLECTION':
            return (
              <RecurringEventCollectionCard
                key={node.id}
                t={t}
                recurringEventCollection={node}
                itemOrder={index}
              />
            )
          default:
            return null
        }
      })}
    </>
  )
}

DiscoverFeed.propTypes = {
  t: PropTypes.func.isRequired,
}

export default DiscoverFeed
